<template>
    <div>
        <el-form ref="form" :model="request" label-position="right">
          <el-form-item><el-input v-model="request.name" placeholder="名称" style="width:150px" clearable></el-input></el-form-item>
           <el-form-item>
            <el-button plain type="success" icon="el-icon-plus" @click="addPostionUser">添加职位用户</el-button>
            <el-button plain type="warning" icon="el-icon-plus" @click="addManager">添加自由人</el-button>
            <el-button plain type="primary" icon="el-icon-search" @click="getPcUserList">搜索</el-button>
            <el-button plain type="danger" icon="el-icon-refresh" @click="reset">重置</el-button>
            
           </el-form-item>
        </el-form>
        <el-table :data="response.data" style="margin:auto;width:calc(100% - 30px)" height="715" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}">
            <el-table-column label="用户名称" align="center" prop="name"></el-table-column>
            <el-table-column label="登录账号" align="center" prop="account"></el-table-column>
            <el-table-column label="角色性质" align="center"><template slot-scope="scope"><el-tag>{{scope.row.userNature}}</el-tag></template>
            </el-table-column>
            <el-table-column label="角色职位" align="center"><template slot-scope="scope"><el-tag>{{scope.row.position}}</el-tag></template>
            </el-table-column>
            <el-table-column label="账号状态" align="center"><template slot-scope="scope"><el-tag>{{scope.row.state}}</el-tag></template></el-table-column>
            
      </el-table>
      <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
    <add-manager v-if="addManagerDialog" ref="addManager" @add-succeed="addSucceed"></add-manager>
    </div>
</template>
<script>
import {getPcUser} from '../../api/sys/pcManager.js'
import AddManager from './addManager.vue'
export default {
    name: "PcManager",
    components: {AddManager},
    data() {
        return {
            request: {
                name: '',
                current: '',
                size: ''
            },
            query: {current: 1,size: 20},
            response: {data: [], total: 0},
            addManagerDialog: false
        }
    },
    methods: {
        getPcUserList(){
            this.request.current = this.query.current;
            this.request.size = this.query.size;
            getPcUser(this.request).then(result=>{
                this.response.data = result.data.records;
                this.response.total = result.data.total;
            })
        },
        currenChangeHandle(value){
            this.query.current = value;
            this.getPcUserList();
        },
        reset(){
            this.query.current = 1;
            this.request.name = "";
            this.getPcUserList();
        },
        addPostionUser(){
            this.addManagerDialog = true;
            this.$nextTick(()=>{
                this.$refs.addManager.init();
            })
        },
        addSucceed(){
            this.getPcUserList();
        }
    },
    created() {
        this.getPcUserList();
    }
}
</script>
<style scoped>
.el-form {
  float: left;
}

.el-form-item {
    display: inline-block !important;
  }
</style>


// WEBPACK FOOTER //
// src/pages/sys/pcmanager.vue